module.exports = __webpack_public_path__ + "static/media/car2-logo1.0fce8978.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/brand/car2-logo1.png
// module id = 695
// module chunks = 0